export default __webpack_public_path__ + "static/media/IBimageScissors2.4879b7a7.png";